<template>
    <div class="login-container">
        <div class="row">
            <div class="col-lg-2 sidebar">
                <h1 class="font-weight-normal pb-3">Login or Sign Up</h1>
                <div class="lines h-100 d-sm-none d-none d-lg-block"></div>
            </div>
            <div class="col-lg-10">

                <div v-if="loading">
                    <div class="vh-100 d-flex justify-content-center align-items-center">
                        <vue-loaders-ball-beat scale="2" color="black" />
                    </div>
                </div>
                <div v-else>

                    <div>
                        <h2>This area is restricted to Employees and Rep Agents only</h2>
                        <p>If you are a rep agent or employee of Westchester, we invite you to sign up for the My Tools area of our website, where you can access additional forms, sales documents and website tools. Any other person is not permitted access to this section, but can still use the main westchestergear.com website.</p>
                        <i>* Please sign up using your corporate email address in order to make the verification process faster.</i>

                        <div class="mt-4">
                            <transition name="fade" v-if="currentParam.login=='false'">
                                <fatal-error>Could not login, your credentials do not match our records. Please try again. </fatal-error>
                            </transition>
                            <transition name="fade" v-if="currentParam.verify=='false'">
                                <fatal-error>You are not authorized to access distributor tools. Please wait while we verify your email. </fatal-error>
                            </transition>
                            <transition name="fade" v-if="currentParam.access=='false'">
                                <fatal-error>Distributor Tools access not granted.</fatal-error>
                            </transition>

                            <transition name="fade" v-if="currentParam.password=='true'">
                                <success>Your password has been reset. Please login with your updated credentials. </success>
                            </transition>


                            <transition name="fade" v-if="currentParam.register=='true'">
                                <success>Your registration is complete please wait while we verify your email. </success>
                            </transition>

                            <transition name="fade" v-if="currentParam.register=='false'">
                                <fatal-error>Your email address already exists in our system please login.</fatal-error>
                            </transition>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-5">
                            <div class="my-3">
                                <h3>LOGIN: <span>I HAVE A PASSWORD</span></h3>
                                <form>
                                    <div class="form-group">
                                        <label for="email">Email Address:</label>
                                        <input type="text" name="user_email" class="form-control" v-model="user_email"
                                        :class="[{'is-invalid': errorFor('user_email')}]">
                                        <v-errors :errors="errorFor('email')"></v-errors>
                                    </div>
                                    <div class="form-group">
                                        <label for="password">Password:</label>
                                        <input type="password" name="user_password"  class="form-control" v-model="user_password"
                                        :class="[{'is-invalid': errorFor('user_password')}]">
                                        <v-errors :errors="errorFor('user_password')"></v-errors>
                                    </div>
                                    <button class="btn-round-red pt9rem" type="submit" :disabled="loading" @click.prevent="login">Login</button>
                                    <hr />
                                    <div class="text-nowrap">
                                        Forgotten password?
                                        <router-link :to="{path: '/reset-password'}" class="font-weight-bold">Reset password</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-1"></div>
                        <div class="col-md-5">
                            <div class="my-3">
                                <h3>SIGN UP: <span>I don't have a password</span></h3>
                                <div >
                                    <form autocomplete="false">
                                        <div class="form-group">
                                            <label for="name">* First Name:</label>
                                            <input type="text" name="firstname"  class="form-control" v-model="user.firstname"
                                            :class="[{'is-invalid': errorFor('firstname')}]">
                                            <v-errors :errors="errorFor('firstname')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="name">* Last Name:</label>
                                            <input type="text" name="lastname"  class="form-control" v-model="user.lastname"
                                            :class="[{'is-invalid': errorFor('lastname')}]">
                                            <v-errors :errors="errorFor('lastname')"></v-errors>
                                        </div>


                                        <div class="form-group">
                                            <label for="company">* Company:</label>
                                            <input type="text" name="company"  class="form-control" v-model="user.company"
                                            :class="[{'is-invalid': errorFor('company')}]">
                                            <v-errors :errors="errorFor('company')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="title">* Title:</label>
                                            <input type="text" name="title" class="form-control" v-model="user.title"
                                            :class="[{'is-invalid': errorFor('title')}]">
                                            <v-errors :errors="errorFor('title')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="">* Address:</label>
                                            <input type="text" name="address" class="form-control" v-model="user.address"
                                            :class="[{'is-invalid': errorFor('address')}]">
                                            <v-errors :errors="errorFor('address')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="">Address Line 2:</label>
                                            <input type="text" name="address2"  class="form-control" v-model="user.address2"
                                            :class="[{'is-invalid': errorFor('address2')}]">
                                            <v-errors :errors="errorFor('address2')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="">* City:</label>
                                            <input type="text" name="city"  class="form-control" v-model="user.city"
                                            :class="[{'is-invalid': errorFor('city')}]">
                                            <v-errors :errors="errorFor('city')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="">* State:</label>
                                            <input type="text" name="state"  class="form-control" v-model="user.state"
                                            :class="[{'is-invalid': errorFor('state')}]">
                                            <v-errors :errors="errorFor('state')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="zipcode">* Zipcode:</label>
                                            <input type="text" name="zipcode"  class="form-control" v-model="user.zipcode"
                                            :class="[{'is-invalid': errorFor('zipcode')}]">
                                            <v-errors :errors="errorFor('zipcode')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="phone">* Phone Number:</label>
                                            <input type="text" name="phone" class="form-control" v-model="user.phone"
                                            :class="[{'is-invalid': errorFor('phone')}]">
                                            <v-errors :errors="errorFor('phone')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="email">* Email:</label>
                                            <input type="text" name="email" class="form-control" v-model="user.email"
                                            :class="[{'is-invalid': errorFor('email')}]" role="presentation" autocomplete="none">
                                            <v-errors :errors="errorFor('email')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="password">* Password: <span>(MINIMUM OF 6 CHARACTERS)</span></label>
                                            <input type="password" name="password" class="form-control" v-model="user.password"
                                            :class="[{'is-invalid': errorFor('password')}]" role="presentation" autocomplete="off">
                                            <v-errors :errors="errorFor('password')"></v-errors>
                                        </div>
                                        <div class="form-group">
                                            <label for="password_confirmation">* Confirm Password:</label>
                                            <input type="password" name="password_confirmation" class="form-control" v-model="user.password_confirmation"
                                            :class="[{'is-invalid': errorFor('password_confirmation')}]">
                                            <v-errors :errors="errorFor('password_confirmation')"></v-errors>
                                        </div>
                                        <div>
                                            <input type="hidden" name="via" value="web" />

                                        </div>
                                        <button class="btn-round-red pt9rem" type="submit" :disabled="loading" @click.prevent="register" >SIGN UP</button>
                                        <hr />
                                        <div class="text-nowrap">
                                            Already have an account?
                                            <router-link :to="{name: 'login'}" class="font-weight-bold">Log-in</router-link>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>



</template>
<style lang="scss" scoped>
    .login-container{
        width:90%;
        margin:4em auto 0 auto;

        i{
            color:#cd1b00;
        }
        h1{
            border-bottom: 3px solid #efefef;
            font-size:3em;
            margin: 0 0 1.6rem 0;
            color:#111;
        }
        h3 {
            color: #cd1b00;
            font-weight:600;
            border-bottom:1px solid #cd1b00;
            margin-bottom:1em;
            span{
                font-weight: 400;
                font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
            }
        }
        label{
            text-transform: uppercase;
            font-weight:600;
            margin-bottom:0;
            span{
                font-size: 0.75rem;
                color: #666666;
                font-weight:400;
                margin: 1rem 0;
            }
        }
    }

</style>

<script>
import validationErrors from '../components/mixins/validationErrors';
import { logIn, logOut } from "../components/utils/auth";
    export default{
        mixins: [validationErrors],
        data(){
            return{
                user_email:null,
                user_password:null,
                loading:false,
                success:null,
                user:{ },
                errors:null,
            };
        },
        computed:{
            currentParam(){
                return this.$route.query;
            },
        },
        created(){
            // if (this.$route.path=="/auth/login/verify"){
            //       axios.get(`/api/verify/${this.$route.query.code}`).then(response=>{
            //             if(response.data){
            //                 this.verifyUser=true;
            //                 var self=this;
            //                 setTimeout(function(){
            //                     self.verifyUser=false;
            //                 }, 5000);
            //             }else{
            //                 this.verifyInvalid=true;
            //                 var self=this;
            //                 setTimeout(function(){
            //                     self.verifyInvalid=false;
            //                 }, 5000);
            //             }

            //         });
            // }
            // if(this.$route.query.errorLogin=='true'){
            //     this.errorLogin=true;
            //     var self=this;
            //     setTimeout(function(){
            //         self.errorLogin=false;
            //     }, 3000);
            // }
        },
        methods:{

            // verify if the user email and password is correct
            async login(){
                window.scrollTo(0,0);
                this.loading=true;
                try {
                    // Browser login state can be cleared by a failed API call
                    // while Laravel's web session is still valid. Recover that
                    // session before posting to the guest-only login endpoint.
                    try {
                        const sessionResponse = await axios.get(`/user`);
                        if(sessionResponse.data){
                            this.completeLogin(sessionResponse.data);
                            return;
                        }
                    } catch (error) {
                        // No active session; continue with a normal login.
                    }

                    await axios.get(`/sanctum/csrf-cookie`);
                    await axios.post(`/login`, {
                            email: this.user_email,
                            password: this.user_password
                        }).then(response=>{
                            console.log(response.data);
                            if(response.data.success){
                                this.completeLogin(response.data.user);
                            }
                            else{
                                this.loading=false;

                                switch(response.data.msg){
                                    case "Not Verified":
                                        this.$router.push({ name: "login", query: {verify: "false"} });
                                        break;
                                    case "No Access":
                                        this.$router.push({ name: "login", query: {access: "false"} });
                                        break;
                                }
                            }
                        });
                } catch (error) {

                    this.loading=false;
                    this.$router.push({ name: "login", query: {login: "false"} });

                }
            },

            completeLogin(user){
                logIn(user.email, user.approved, user.user_group_id);
                axios.get(`/api/user/update/login/${user.id}`);
                this.$store.dispatch("loadUser");
                this.loading=false;

                if(this.$route.query.from){
                    this.$router.push({ name: this.$route.query.from});
                }else{
                    this.$router.push({ name: "home"});
                }
            },

            async register(){
                this.loading=true;
                window.scrollTo(0,0);
                let checkUser={};

                try {
                    checkUser=await axios.get(`/api/getUserByEmail/${this.user.email}`);

                    if(checkUser.data){
                        this.$router.push({ name: "login", query: {register: "false"} });
                    }else{
                        await axios.post(`/register`, this.user).then(response=>{
                            this.$router.push({ name: "login", query: {register: "true"} });
                            // initializing the user object
                            this.user={};
                            this.loading=false;
                        });
                    }

                } catch (error) {
                    this.loading=false;
                    this.errors=error.response && error.response.data.errors;
                }


            },



        }
    };
</script>
